import HistoryMetrics from './HistoryMetrics';

export default HistoryMetrics;
